/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 書籍の購買形式。default: サブスクで閲覧可能, purchasable: 買い切りで閲覧可能 
 * @export
 * @enum {string}
 */

export const PurchaseTypeEnum = {
    Default: 'default',
    Purchasable: 'purchasable'
} as const;

export type PurchaseTypeEnum = typeof PurchaseTypeEnum[keyof typeof PurchaseTypeEnum];



